import React, {useContext, useEffect} from 'react';
import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import FormControlLabel from "components/radioGroup/FormControlLabel";
import SelectTitle from "components/radioGroup/SelectTitle";
import RadioGroup from "components/radioGroup/RadioGroup";

import {ListContext} from "components/List/context/ListContext";

function ReturnShippingMethodOverride(props) {
    const {values, setFieldValue, setFieldTouched, validateField} = useFormikContext();

    const {notFilteredListItems} = useContext(ListContext);

    useEffect(() => {
        validateField('printConfig');
    }, [values.printConfig?.returnShippingMethodOverride]);

    function findShippingMethodNameByShopName(shopName) {
        if (shopName) {
            return notFilteredListItems.find(shippingMethod => shippingMethod.shopName === shopName)?.name;
        }

        return '';
    }

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.printConfig.returnShippingMethodOverride.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={props.intl.formatMessage({id: 'shippingMethods.form.field.printConfig.returnShippingMethodOverride.placeholder'})}
                selectedValueLabel={findShippingMethodNameByShopName(values?.printConfig?.returnShippingMethodOverride ?? '')}
                name={'printConfig.returnShippingMethodOverride'}
                value={values.printConfig.returnShippingMethodOverride}
                onClickAway={() => setFieldTouched('printConfig.returnShippingMethodOverride')}
                onChange={(event, value) => {
                    setFieldValue('printConfig', {
                        ...values.printConfig,
                        returnShippingMethodOverride: value,
                        printReturnWaybill: true,
                    }, false)
                }}
            >
                {notFilteredListItems.map((shippingMethod, index) => (
                    <FormControlLabel
                        key={index}
                        value={shippingMethod.shopName}
                        label={shippingMethod.name || shippingMethod.shopName}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default injectIntl(ReturnShippingMethodOverride);
